import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-send-email",
  "use": "icon-s-send-email-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-send-email\"><path d=\"M19 3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2H3v12h16zm-.375-.534L20 6l-8.313 6.74c-.359.318-.885.344-1.273.08l-.101-.08L2 6l1.375-1.534L11 10.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol